import React, { ChangeEvent } from 'react'
import { InputContainer, Input, Label } from '../input/style'
import { ITextInputProps } from '../../../types/interfaces/ITextInputProps'
import { Error } from '../error/Error'
import { useAppSelector } from 'store/store'

export const TextInput: React.FC<ITextInputProps> = ({
  callback,
  hasError,
  errorText,
  className,
  minLength,
  label,
  id,
  value,
  disabled,
  isRequired,
  regex,
  maxLength,
}) => {
  const isLoading = useAppSelector((state) => state.layout.isLoading)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    const error =
      e.target.value.length < minLength ||
      (maxLength && e.target.value.length > maxLength) ||
      (regex && !regex.test(e.target.value))
    callback(e.target.value, error)
  }

  return (
    <InputContainer
      className={`textInput ${className ?? ''} ${hasError ? 'error' : ''}`}
    >
      <Label htmlFor={id}>
        {label}
        {isRequired && <span style={{ color: 'red' }}>*</span>}
      </Label>
      <Input
        className={className}
        title={disabled ? 'לא ניתן לערוך שדה זה' : ''}
        disabled={disabled || isLoading}
        value={value}
        type="text"
        name={id}
        onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(e)}
        max={maxLength}
      ></Input>
      <Error hasError={hasError} errorText={errorText}></Error>
    </InputContainer>
  )
}
